import { findGeomNode } from "./geomSelection.js";
import { duplicateSequenceName } from "./uniqueNames.js";

function cloneStructured(value) {
  if (value == null) return value;
  try {
    return structuredClone(value);
  } catch {
    try {
      return JSON.parse(JSON.stringify(value));
    } catch {
      return value;
    }
  }
}

function makeUniqueGeomName(baseName, siblingGeoms) {
  if (!baseName) return baseName;
  const existingNames = (Array.isArray(siblingGeoms) ? siblingGeoms : [])
    .map((geom) => geom?.name)
    .filter(Boolean);
  return duplicateSequenceName(baseName, existingNames, "_", "geom");
}

/**
 * Duplicate a geom onto a target body.
 *
 * @param {object} params
 * @param {string} params.sourceGeomKey
 * @param {string | null} [params.targetBodyUuid]
 * @param {Function} params.getSceneState
 * @param {object} params.sceneActions
 * @returns {string | null}
 */
export function duplicateBodyGeom({
  sourceGeomKey,
  targetBodyUuid = null,
  getSceneState,
  sceneActions,
}) {
  if (!sourceGeomKey) return null;
  const sceneState = getSceneState?.();
  const resolved = findGeomNode(sceneState?.bodies, sourceGeomKey);
  const sourceGeom = resolved?.geom || null;
  const destinationBodyUuid = targetBodyUuid || resolved?.bodyUuid || null;
  if (!sourceGeom || !destinationBodyUuid) return null;
  const destinationBody = sceneState?.bodies?.[destinationBodyUuid] || null;

  const clonedGeom = cloneStructured(sourceGeom);
  if (!clonedGeom || typeof clonedGeom !== "object") return null;
  delete clonedGeom.uuid;
  if (clonedGeom.name) {
    clonedGeom.name = makeUniqueGeomName(clonedGeom.name, destinationBody?.geoms);
  }

  return sceneActions.addGeom(clonedGeom, destinationBodyUuid);
}
